<template lang="pug">
.app-copy-input-value
  .input-group
    input.form-control(
      ref="inputValue"
      :value="value"
      readonly
      :placeholder="placeholder"
      @click="selectInputText"
    )
    span.input-group-addon(
      v-if="showCopy"
      :disabled="disableCopy ? 'disabled' : null"
      :class="{ pressed: btnPressed }"
      @click.prevent="copyInputValue"
    )
      a.copy-link {{ btnText }}
</template>

<script>
export default {
  name: 'AppCopyInputValue',
  props: {
    value: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'Copy',
    },
    copiedText: {
      type: String,
      default: 'Copied',
    },
    analyticsEventSource: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    btnPressed: false,
  }),
  computed: {
    showCopy() {
      return !!navigator.clipboard;
    },
    disableCopy() {
      return !this.value;
    },
    btnText() {
      return this.btnPressed ? this.copiedText : this.buttonText;
    },
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    selectInputText() {
      this.$refs.inputValue.select();
    },
    deSelectInputText() {
      this.$refs.inputValue.blur();
    },
    async startCopy() {
      await navigator.clipboard.writeText(this.value);
      this.selectInputText();
      this.btnPressed = true;
    },
    stopCopy() {
      this.deSelectInputText();
      this.btnPressed = false;
      clearInterval(this.interval);
    },
    copyInputValue() {
      if (this.btnPressed) {
        return;
      }

      try {
        this.startCopy();
        this.interval = setInterval(() => {
          this.stopCopy();
        }, 3000);

        if (this.analyticsEventSource) {
          this.trackEvent();
        }

      } catch (e) {
        this.$appMessage('There was an unexpected error');
      }
    },
    trackEvent() {
      window.analytics?.track('Copy to clipboard', {
        source: this.analyticsEventSource,
      });
    },
  },
};
</script>
